import { CPMTransition, CPMTransitionResponse } from "@/features/home/types";
import { round } from "@/features/home/utils";

export const processCPMTransition = (data: CPMTransitionResponse): CPMTransition => {
  const processedData = {
    date: [],
    cpm: [],
    avg: [],
  } as CPMTransition;
  data.cpmTransitions.forEach(value => {
    processedData.date.push(value.date);
    if (value.cpm === null) processedData.cpm.push(value.cpm);
    else processedData.cpm.push(round(value.cpm));
    if (value.avg === null) processedData.avg.push(value.avg);
    else processedData.avg.push(round(value.avg));
  });
  return processedData;
};
